import { api } from '../../../../app/auth/apiSlice';
import queryParams from '../../../../utils/paramQuery-utils';

const profileApi = api
  .enhanceEndpoints({
    addTagTypes: ['profile', 'award'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // menus
      updateUserProfile: builder.mutation({
        query: ({ phone2, hobbies, about }) => ({
          url: `/v1/main/user/profile/`,
          method: 'PATCH',
          body: {
            phone2,
            hobbies,
            about,
          },
        }),
        invalidatesTags: ['profile'],
      }),
      getAwards: builder.query({
        query: (arg) => {
          const params = queryParams(arg);
          return `v1/main/user/awards/${params}`;
        },
        providesTags: ['award'],
        keepUnusedDataFor: 1,
      }),
      addAwards: builder.mutation({
        query: (arg) => {
          return {
            url: `v1/main/user/awards/`,
            method: 'POST',
            body: arg,
          };
        },
        invalidatesTags: ['award'],
      }),
      deleteAwards: builder.mutation({
        query: (id) => {
          return {
            url: `v1/main/user/awards/${id}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['award'],
      }),
      updateAwards: builder.mutation({
        query: ({ id, value }) => {
          return {
            url: `v1/main/user/awards/${id}`,
            method: 'PATCH',
            body: value,
          };
        },
        invalidatesTags: ['award'],
      }),
    }),
  });

export const {
  useUpdateUserProfileMutation,
  useGetAwardsQuery,
  useAddAwardsMutation,
  useDeleteAwardsMutation,
  useUpdateAwardsMutation,
} = profileApi;
